import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";

import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import FontAwesomeIcon from '@ntag/react-fontawesome';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    flexDirection: "column",
    width: "min-content",
    minWidth: "350px",
    maxWidth: "80%",
    maxHeight: "80%"    
  },
  overlay: {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0,0,0, 0.5)",
    zIndex: "99"
  }
};

const Tooltip = ({ content, dataId, openFromStart }) => {
  const [modalIsOpen, isModalIsOpen] = useState(openFromStart);
  const colorGran = "#1b5f4b";

  return (
    <>
      {!openFromStart && <FontAwesomeIcon
        data-id={dataId}
        icon={faQuestionCircle}
        onClick={() => isModalIsOpen(true)}
        fill={colorGran}
      />}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => isModalIsOpen(false)}
        appElement={document.getElementsByClassName("lfc-container")}
        style={customStyles}
      >
        <FontAwesomeIcon
          data-id={dataId}
          icon={faCircleXmark}
          onClick={() => isModalIsOpen(false)}
          fill={colorGran}
          style={{
            position: "absolute", 
            top: "4px", 
            right: "4px",
            fontSize: "18px"
          }}
        /> 
        {<div dangerouslySetInnerHTML={{__html: content}}/>}
      </Modal>
    </>
  );
};

export default Tooltip;

Tooltip.propTypes = {
  content: PropTypes.string.isRequired,
  dataId: PropTypes.string,
  openFromStart: PropTypes.bool,
};
